<template>
  <div class="personalized-questions">
    <div class="personalized-questions__content">
      <questions-form :forms="forms" :answers="answers" :answered="answered" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.personalized-questions {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.personalized-questions__content {
  width: 95%;
  margin: 16px auto 10px;

  display: flex;

  background-color: #fff;
}
</style>

<script>
import axios from "axios";
import { isEmpty, set, get } from "lodash";
import { pipe } from "lodash/fp";
import QuestionsForm from "./components/QuestionsForm.vue";

export default {
  components: { QuestionsForm },
  data: () => ({
    forms: [],
    answers: {},
    answered: []
  }),
  methods: {
    setAnsweredQuestions(forms) {
      forms.forEach(form => {
        form.questions.forEach(({ answer }) => {
          if (isEmpty(answer.value)) return;

          this.answered = [
            ...this.answered,
            {
              question_id: answer.id,
              value: answer.answer.value
            }
          ];
        });
      });

      return forms;
    },
    setOnlyNotAnsweredQuestions(forms) {
      forms.forEach(form =>
        form.questions.forEach(question => {
          if (!isEmpty(question.answer.value)) return;
          set(this.answers, question._id, {
            question_id: question._id,
            value: question.answer.value || ""
          });
        })
      );

      return forms;
    },
    getOnlyUnanswaredQuestionsInForms(forms) {
      if (!forms.length) return [];

      this.forms = forms.map(form => ({
        ...form,
        questions: form.questions.filter(({ answer }) => isEmpty(answer.value))
      }));

      return forms;
    },
    shouldRedirectToNextStep(forms) {
      const questions = forms.map(form => form.questions).flat();
      if (questions.length === this.answered.length) {
        const { params } = this.$router.history.current;
        this.$router.push({
          name: "dashboard-vacancy",
          params,
          query: {
            success: true,
          }
        });
      }
    },
    async fetchForms() {
      this.$vs.loading({
        text: "Buscando perguntas..."
      });

      try {
        const { vacancy_id, step_id } = this.$router.history.current.params;

        // const response = await this.$http.get(
        //   `/api/v1/questions/steps/vacancies/${vacancy_id}/${step_id}`
        // );
        // const baseURL = process.env.VUE_APP_CURRICULUM_SERVICE;
        // const url = `/api/v1/questions/steps/vacancies/${vacancy_id}/${step_id}`;
        // const response = await axios.get(url, { baseURL });
        const token = this.$store.getters["auth/token"];
        const baseURL = process.env.VUE_APP_CURRICULUM_SERVICE;
        const url = `/api/v1/questions/steps/vacancies/${vacancy_id}/${step_id}`;
        const config = {
          baseURL,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        };
        const response = await axios.get(url, config);

        const { forms = [] } = response.data.data;

        pipe(
          this.setAnsweredQuestions,
          this.setOnlyNotAnsweredQuestions,
          this.getOnlyUnanswaredQuestionsInForms,
          this.shouldRedirectToNextStep
        )(forms);

        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        if ([304, 404, 409].includes(get(error, "response.status", null))) {
          const { params } = this.$router.history.current;
          this.$router.push({
            name: "dashboard-vacancy",
            params,
            query: {
              success: true,
            }
          });
        }
      }
    }
  },
  created() {
    this.fetchForms();
  }
};
</script>
